const PROPERTIES = {
  screen_type: {
    type: 'string',
    required: true,
  },
  screen_name: {
    type: 'string',
    required: true,
    canBeUppercase: true,
  },
  screen_id: {
    type: 'string',
  },
  screen_url: {
    type: 'string',
  },
  layout_name: {
    type: 'string',
  },
  layout_id: {
    type: 'string',
  },
  is_logged_in: {
    type: 'boolean',
  },
  screen_state: {
    type: 'string',
  },
  source: {
    type: 'string',
  },
  tab_name: {
    type: 'string',
  },
  tab_id: {
    type: 'string',
  },
  filter_name: {
    type: 'string',
  },
  ui_element_type: {
    type: 'string',
  },
  ui_element_name: {
    type: 'string',
    canBeUppercase: true,
  },
  ui_element_title: {
    type: 'string',
  },
  ui_element_position: {
    type: 'int',
  },
  ui_element_id: {
    type: 'string',
  },
  feature_type: {
    type: 'string',
  },
  feature_name: {
    type: 'string',
    canBeUppercase: true,
  },
  feature_position: {
    type: 'int',
  },
  feature_destination_url: {
    type: 'string',
  },
  feature_id: {
    type: 'string',
    canBeUppercase: true,
  },
  merchant_name: {
    type: 'string',
    canBeUppercase: true,
  },
  merchant_id: {
    type: 'string',
  },
  opportunity_type: {
    type: 'string',
  },
  offer_type: {
    type: 'string',
    transformValue: [
      {
        fromRegex: 'sboc-[a-z]+',
        toValue: 'oc',
      },
    ],
  },
  interact_type: {
    type: 'string',
  },
  outlet_name: {
    type: 'string',
  },
  brand_name: {
    type: 'string',
  },
  partner_name: {
    type: 'string',
  },
  is_sponsored: {
    type: 'boolean',
  },
  is_affiliate: {
    type: 'boolean',
  },
  has_tooltip: {
    type: 'boolean',
  },
  current_url: {
    type: 'string',
  },
  referrer_url: {
    type: 'string',
  },
  utm_campaign: {
    type: 'string',
  },
  utm_content: {
    type: 'string',
  },
  utm_id: {
    type: 'string',
  },
  utm_medium: {
    type: 'string',
  },
  utm_source: {
    type: 'string',
  },
  utm_term: {
    type: 'string',
  },
  has_coupon: {
    type: 'boolean',
  },
  sku_category_name: {
    type: 'string',
  },
  sku_category_id: {
    type: 'string',
  },
  is_brand_official: {
    type: 'boolean',
  },
  is_power_seller: {
    type: 'boolean',
  },
  search_keyword_input: {
    type: 'string',
  },
  search_comparison_type: {
    type: 'string',
  },
  search_keyword_type: {
    type: 'string',
  },
  flow_type: {
    type: 'string',
  },
  shoppingtrip_uuid: {
    type: 'string',
  },
  page_track_meta_model_name: {
    type: 'string',
  },
  page_track_meta_model_version: {
    type: 'string',
  },
  page_track_meta_track_id: {
    type: 'string',
  },
  offer_id: {
    type: 'string',
  },
  offer_name: {
    type: 'string',
  },
  opportunity_id: {
    type: 'string',
  },
  partner_id: {
    type: 'string',
  },
  partner_salesforce_id: {
    type: 'string',
  },
  segment_key: {
    type: 'string',
  },
  sku_brand_name: {
    type: 'string',
  },
  sku_subcategory_name: {
    type: 'string',
  },
  experiment_variant: {
    type: 'string',
  },
  experiment_key: {
    type: 'string',
  },
  campaign_id: {
    type: 'string',
  },
  curation_type: {
    type: 'string',
  },
  curation_name: {
    type: 'string',
  },
  curation_id: {
    type: 'string',
  },
  zone_name: {
    type: 'string',
  },
  zone_id: {
    type: 'string',
  },
  asset_name: {
    type: 'string',
  },
  flight_id: {
    type: 'string',
  },
  is_paylater: {
    type: 'boolean',
  },
  is_upsize: {
    type: 'boolean',
  },
  is_promo: {
    type: 'boolean',
  },
  is_ams: {
    type: 'boolean',
  },
  seller_name: {
    type: 'string',
    canBeUppercase: true,
  },
  seller_id: {
    type: 'string',
  },
  base_cashback_percentage: {
    type: 'string',
  },
  sell_price_cents: {
    type: 'string',
  },
  ui_element_ml_id: {
    type: 'string',
  },
  asset_id: {
    type: 'string',
  },
  content_source_name: {
    type: 'string',
  },
  group_buy_cashback: {
    type: 'string',
  },
  orca_request_id: {
    type: 'string',
  },
  curation_version: {
    type: 'string',
  },
  user_location: {
    type: 'string',
  },
  feature_state: {
    type: 'string',
  },
  merchant_type: {
    type: 'string',
  },
  error_name: {
    type: 'string',
  },
  error_code: {
    type: 'string',
  },
  error_type: {
    type: 'string',
  },
  error_message: {
    type: 'string',
  },
  is_welcome_offer: {
    type: 'boolean',
  },
  qr_code_type: {
    type: 'string',
  },
  is_disabled: {
    type: 'boolean',
  },
  payment_method: {
    type: 'string',
  },
  is_default_billing_card: {
    type: 'boolean',
  },
  layout_uid: {
    type: 'string',
  },
  previous_uid: {
    type: 'string',
  },
  component_uid: {
    type: 'string',
  },
  content_uid: {
    type: 'string',
  },
  experiment_variant: {
    type: 'string',
  },
  show_corner_tag: {
    type: 'boolean',
  },
  show_merchant_name: {
    type: 'boolean',
  },
  show_cashback: {
    type: 'boolean',
  },
  merchant_rewards: {
    type: 'string',
  },
  show_bottom_tag: {
    type: 'boolean',
  },
  corner_tag_name: {
    type: 'string',
  },
  l1_category_name: {
    type: 'string',
  },
  l2_category_name: {
    type: 'string',
  },
  user_location: {
    type: 'string',
  },
  outlet_id: {
    type: 'string',
  },
  has_adblock: {
    type: 'boolean',
  },
  has_extension: {
    type: 'boolean',
  },
  bottom_tag_name: {
    type: 'string',
  },
  challenge_tag: {
    type: 'string',
  },
  has_badge: {
    type: 'boolean',
  },
  offer_group_id: {
    type: 'string',
  },
  is_ad: {
    type: 'boolean',
  },
  is_recommended: {
    type: 'boolean',
  },
  shopback_session_id: {
    type: 'string',
  },
  web_platform: {
    type: 'string',
  },
  document_type: {
    type: 'string',
  },
  payment_method_used: {
    type: 'string',
  },
  overlay_text_type: {
    type: 'string',
  },
  outlet_rewards: {
    type: 'array',
    arrayItems: 'string',
  },
  outlet_payment_options: {
    type: 'array',
    arrayItems: 'string',
  },
  badge_number: {
    type: 'string',
  },
  is_official: {
    type: 'boolean',
  },
  brand_id: {
    type: 'string',
  },
  timestamp: {
    type: 'int',
  },
  accountUuid: {
    type: 'string',
  },
  shopback_session_id: {
    type: 'string',
  },
  has_adblock: {
    type: 'boolean',
  },
  has_extension: {
    type: 'boolean',
  },
  browser_name: {
    type: 'string',
  },
  browser_version: {
    type: 'string',
  },
  tracking_owner: {
    type: 'string',
  },
  merchant_checkout_platform: {
    type: 'string',
  },
  display_locale: {
    type: 'string',
    canBeUppercase: true,
  },
  locale: {
    type: 'string',
    canBeUppercase: true,
  },
  extension_version: {
    type: 'string',
  },
  affiliate_link_id: {
    type: 'string',
  },
  redirect_destination_type: {
    type: 'string',
  },
  redirect_issue: {
    type: 'string',
  },
  previous_screen_url: {
    type: 'string',
  },
  user_agent: {
    type: 'string',
    canBeUppercase: true,
  },
  screen_resolution: {
    type: 'string',
  },
}

export default PROPERTIES
